<template>
    <v-app :style="{background: $vuetify.theme.background}">
        <app-navigation></app-navigation>
        <v-content transition="slide-x-transition">
            <router-view/>
        </v-content>
    </v-app>
</template>

<script>
import AppNavigation from '@/components/AppNavigation';

export default {
    name: 'App',
    components: {
        AppNavigation,
    },
};
</script>